var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05719 12.9772L7.0565 12.9762L7.05306 12.9733L7.05719 12.9772ZM20.1328 9.91736L18.6154 4.24016L13.1003 0L1.67131 8.61546L0 14.9305L6.7375 20L6.84819 13.1288L1.60669 8.89645L2.05631 9.23286L1.79988 9.02382L2.71563 9.7122L1.88238 9.02382L7.0565 12.9762L18.1974 4.83228L16.4141 6.21682L18.502 4.7088L14.3694 7.8036L7.19606 13.3719L6.73681 19.999L20.1321 9.91541L20.1328 9.91736ZM7.27994 10.9947L4.2625 8.71755L7.19744 10.001L16.1831 4.36169L7.27994 10.9947Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.bdea179f93a27dbbe139b4777033f9c6.svg";
export { ForwardRef as ReactComponent };